/**
 * Accessible profile tab switching.
 */
export const initTabs = (navButtons, tabPanels) => {
    const tabs = Array.from(navButtons).filter(button => button.hasAttribute('data-tab'));
    const panels = Array.from(tabPanels);

    if (!tabs.length || !panels.length) return;

    const getPanel = (tabId) => panels.find(panel => panel.id === `tab-${tabId}`);

    const switchTab = (tabId, moveFocus = false) => {
        const tab = tabs.find(button => button.dataset.tab === tabId);
        const activePanel = getPanel(tabId);
        if (!tab || !activePanel) return;

        tabs.forEach(button => {
            const isSelected = button === tab;
            button.classList.toggle('is-active', isSelected);
            button.setAttribute('aria-selected', String(isSelected));
            button.tabIndex = isSelected ? 0 : -1;
        });

        panels.forEach(panel => {
            const isActive = panel === activePanel;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
        });

        if (moveFocus) tab.focus();

        if (window.location.hash !== `#${tabId}`) {
            history.replaceState(null, '', `#${tabId}`);
        }
    };

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => switchTab(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => {
            let nextIndex;

            switch (event.key) {
                case 'ArrowDown':
                case 'ArrowRight':
                    nextIndex = (index + 1) % tabs.length;
                    break;
                case 'ArrowUp':
                case 'ArrowLeft':
                    nextIndex = (index - 1 + tabs.length) % tabs.length;
                    break;
                case 'Home':
                    nextIndex = 0;
                    break;
                case 'End':
                    nextIndex = tabs.length - 1;
                    break;
                default:
                    return;
            }

            event.preventDefault();
            switchTab(tabs[nextIndex].dataset.tab, true);
        });
    });

    const initialTab = window.location.hash.slice(1);
    if (initialTab && getPanel(initialTab)) {
        switchTab(initialTab);
    } else {
        const selectedTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
        switchTab(selectedTab.dataset.tab);
    }
};
